export const IMAGE_UPLOAD_KINDS = [
  'profile-avatar',
  'profile-cover',
  'company-logo',
  'company-banner',
  'featured-project-image',
  'cv-share-card-bg',
  'feedback-screenshot',
  'skill-icon',
  'profile-block-thumbnail',
] as const;

export type ImageUploadKind = (typeof IMAGE_UPLOAD_KINDS)[number];

export interface CreateImageUploadUrlInput {
  kind: ImageUploadKind;
  fileName: string;
  mimeType: string;
  companyId?: string;
}

export interface CreateImageUploadUrlResult {
  uploadUrl: string;
  fileUrl: string;
  storageKey: string;
  uploadHeaders: Record<string, string>;
}
